import { render, staticRenderFns } from "./DragAndDropCategories.vue?vue&type=template&id=52562946&scoped=true&"
import script from "./DragAndDropCategories.vue?vue&type=script&lang=ts&"
export * from "./DragAndDropCategories.vue?vue&type=script&lang=ts&"
import style0 from "./DragAndDropCategories.vue?vue&type=style&index=0&id=52562946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52562946",
  null
  
)

export default component.exports